import React, { Fragment, ReactNode } from 'react';

// Local props for the component
interface Props {
	children: ReactNode;
}

export default ({ children }: Props) => <Fragment children={children} />;
